import React, { useState } from "react";
import styles from "./SubCategoryModal.module.css";

export default function TrustedContactModal({ data, onSave, onCancel }) {
  const [contacts, setContacts] = useState(data || []);

  const updateContact = (index, field, value) => {
    const updated = [...contacts];
    updated[index][field] = value;
    setContacts(updated);
  };

  const addContact = () => {
    setContacts([
      ...contacts,
      { contactEmail: "", phoneNumber: "" }
    ]);
  };

  const removeContact = (index) => {
    setContacts(contacts.filter((_, i) => i !== index));
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Trusted Contacts</h2>

        {contacts.map((c, i) => (
          <div key={i} className={styles.itemsContainer}>
            <h4>Contact {i + 1}</h4>

            <input
              type="email"
              placeholder="Email"
              value={c.contactEmail}
              onChange={(e) => updateContact(i, "contactEmail", e.target.value)}
              className={styles.input}
            />

            <input
              type="text"
              placeholder="Phone Number"
              value={c.phoneNumber}
              onChange={(e) => updateContact(i, "phoneNumber", e.target.value)}
              className={styles.input}
            />

            <button
              className={styles.removeBtn}
              onClick={() => removeContact(i)}
            >
              Remove
            </button>
          </div>
        ))}

        <button className={styles.addBtn} onClick={addContact}>
          + Add Contact
        </button>

        <div className={styles.footer}>
          <button className={styles.saveBtn} onClick={() => onSave(contacts)}>
            Save
          </button>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
